import { FaSearch } from "react-icons/fa";

const SearchIcon = (props) => {
  return <FaSearch className={props.className} />;
};

export default SearchIcon;
